
  function setDynamicHeights() {
    const header = document.querySelector('.header-wrapper');
    const utility = document.querySelector('.utility-bar');

    if (header) {
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    }

    if (utility) {
      document.documentElement.style.setProperty('--utility-height', `${utility.offsetHeight}px`);
    }
  }

  // Run on load
  window.addEventListener('DOMContentLoaded', setDynamicHeights);

  // Run on resize
  window.addEventListener('resize', setDynamicHeights);

